import charts from '../../charts.js';
import indicatorsChart from '../indicators.js';

export default function({ id, data, config, dates }) {
	const chart = indicatorsChart({ id, data, config, dates });

	chart.addSeries(
		chart.lineSeries({
			legendLabelText: 'Personal Spending',
			valueYField: 'I:USPO',
			stroke: charts.colours.green,
		})
	);

	chart.addSeries(
		chart.lineSeries({
			legendLabelText: 'Disposable Personal Income',
			valueYField: 'I:USDPI',
			stroke: charts.colours.blue,
		})
	);

	return chart;
}
